import { Box, CardContent, Container, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useParams } from "react-router";
import CommCard from "src/common/CommCard";
import DetailsDataShowByGrid from "src/common/DetailsDataShowByGrid";
import GoBackBtn from "src/common/GoBackBtn";
import NoDataFound from "src/common/NoDataFound";
import { useApiQuery } from "src/hooks/useApiQuery";
import { getStatusLabelInvoiceStatus } from "src/Utils/Combined";
import type { IB2B_Invoice } from "../../type/b2bType";
import B2BSingleInvoiceTable from "./B2BSingleInvoiceTable";
import B2BInvoiceWithMoneyReceipt from "../B2BInvoiceWithMoneyReceipt";
import InvoicePaymentComm from "src/content/modules/exhibitor/common/InvoicePaymentComm";

const B2BSingleInvoice = () => {
	const { b2b_invoice_id } = useParams();
	const { data } = useApiQuery<IB2B_Invoice>({
		endPoint: `/api/admin/b2b/invoice/${b2b_invoice_id}`,
		queryKeys: ["b2b-single-MR", b2b_invoice_id],
	});

	return (
		<CommCard helmetTitle='BTTF - B2B Invoice information'>
			<Container sx={{ my: 3 }} maxWidth='xl'>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<GoBackBtn
							showGoBack
							showDetailsIcon
							navigateDetailsLink={`/b2b/list/${data?.b2b_id}`}
							navigateBtnName='GoTo B2B Details'
						/>
						<Box></Box>

						{data ? (
							<>
								<CardContent>
									<Typography
										textAlign='center'
										variant='h4'
										gutterBottom
										sx={{
											marginBottom: "20px",
											textDecoration: "underline",
										}}
									>
										B2B Invoice Details
									</Typography>
									<Grid
										container
										spacing={2}
										justifyContent={"center"}
									>
										<Grid item xs={12}>
											<DetailsDataShowByGrid
												fields={[
													{
														label: "Invoice No",
														value: data.invoice_no,
													},
													{
														label: "VAT",
														value: data.vat,
													},
													{
														label: "Discount",
														value: data.discount,
													},
													{
														label: "Invoice Date",
														value: moment(
															data.invoice_date
														).format("LL"),
													},
													{
														label: "Due Date",
														value: moment(
															data.due_date
														).format("LL"),
													},
													{
														label: "Net Total",
														value: data.net_total,
													},
													{
														label: "Sub Total",
														value: data.sub_total,
													},
													{
														label: "Due",
														value: data.due,
													},

													{
														label: "Client Payment",
														value: data?.clientPayment,
													},
													{
														label: "Status",
														value: getStatusLabelInvoiceStatus(
															data?.status
														),
													},
												]}
											/>

											<>
												{data?.invoicePayment?.length >
													0 && (
													<InvoicePaymentComm
														invoicePayment={
															data?.invoicePayment
														}
													/>
												)}
											</>
										</Grid>

										<Grid item xs={12}>
											<Box
												sx={{
													display: "flex",
													justifyContent:
														"space-between",
												}}
											>
												<Typography
													variant='h6'
													fontWeight='bold'
													gutterBottom
													sx={{
														textAlign: "center",
														textDecoration:
															"underline",
													}}
												></Typography>
												<Typography
													variant='h6'
													fontWeight='bold'
													gutterBottom
													sx={{
														textAlign: "center",
														textDecoration:
															"underline",
														margin: "0 auto",
													}}
												>
													Invoice Items
												</Typography>

												{data?.status !== "Paid" && (
													<B2BInvoiceWithMoneyReceipt
														invoiceDetails={data}
													/>
												)}
											</Box>

											<B2BSingleInvoiceTable
												data={data?.invoice_items}
											/>
										</Grid>
									</Grid>
								</CardContent>
							</>
						) : (
							<NoDataFound />
						)}
					</Grid>
				</Grid>
			</Container>
		</CommCard>
	);
};

export default B2BSingleInvoice;
